import React, { useEffect } from 'react';
import '../PlatformCostObs/dashboard.scss';
import PageHeader from 'components/Header/Page';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BIApplicationIcon from '../../assets/biApplication.svg';
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const DBODashboard = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        const activeId = document.getElementById('root');
        console.log(window.location.pathname);
        if (window.location.pathname.includes('/databricksADB')) {
            if (activeId) {
                document.head.classList.add('theme-bg-blue');
                document.body.classList.add('theme-bg-blue');
            }
        }
    }, []);

    return (
        <div className="base-tab">
            <Box sx={{ width: '100%', marginTop: '-32px' }}>
                <PageHeader title="DBO Dashboard" icon={BIApplicationIcon}> </PageHeader>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                        sx={{
                            fontSize: "12px",
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: 40,
                                fontWeight: 500,
                                borderTopLeftRadius: 4,
                                borderTopRightRadius: 4,
                                backgroundColor: `${theme.palette.Tab.inActive.bgColor} !important`,
                                color: `${theme.palette.Tab.inActive.color} !important`,
                            },
                            '& .MuiTab-root.Mui-selected': {
                                backgroundColor: `${theme.palette.Tab.Active.bgColor} !important`,
                                color: `${theme.palette.Tab.Active.color} !important`,
                            },
                        }}
                    >
                        <Tab label="DBO" {...a11yProps(0)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <iframe
                        title="Databricks Observability Dashboard"
                        width="100%"
                        height="541.25"
                        src="https://app.powerbi.com/reportEmbed?reportId=11dfaa91-431f-4773-aa52-9a61b6cbd566&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&actionBarEnabled=true&reportCopilotInEmbed=true%22"
                        allowFullScreen
                    />
                </CustomTabPanel>
            </Box>
        </div>
    );
};

export default DBODashboard;